import AboutPage from "./AboutPage";

export default [
    {
        path: "/about",
        name: "about",
        component: AboutPage
    },
    {
        path: "/",
        name: "home",
        component: AboutPage
    }
];